module.exports = __webpack_public_path__ + "static/media/fitness-retreat-date-icon.58e85ade.svg";